import * as types from "../actions/types";

const initialState = {
  loading: false,
  error: null,
  threads: { items: [], total: 0, page: 1, page_size: 25, total_pages: 0 },
  currentThread: null,
  messages: [],
  signature: null,
  stats: { unread_count: 0, total_inbox: 0, total_sent: 0, starred_count: 0 },
  contacts: [],
};

const inboxReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.INBOX_SET_LOADING:
      return { ...state, loading: action.payload };
    case types.INBOX_SET_ERROR:
      return { ...state, error: action.payload };
    case types.INBOX_SET_THREADS:
      return { ...state, threads: action.payload };
    case types.INBOX_SET_CURRENT_THREAD:
      return { ...state, currentThread: action.payload };
    case types.INBOX_SET_MESSAGES:
      return { ...state, messages: action.payload };
    case types.INBOX_SET_SIGNATURE:
      return { ...state, signature: action.payload };
    case types.INBOX_SET_STATS:
      return { ...state, stats: action.payload };
    case types.INBOX_SET_CONTACTS:
      return { ...state, contacts: action.payload };
    default:
      return state;
  }
};

export default inboxReducer;
